import { StyleSheet, Dimensions } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

const isIPhoneWithNotch = PlatformUtils.isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  containerStyle: isExpandedTray => ({
    paddingLeft: isExpandedTray ? 0 : 15,
    flex: 1,
  }),
  descriptionContainer: isExpandedTray => ({
    marginLeft: isExpandedTray ? 15 : 0,
    alignSelf: 'flex-start',
    marginTop: 18,
  }),
  descriptionContainerWithSubHeader: {
    alignSelf: 'flex-start',
    marginTop: 18,
  },
  descriptionStyle: theme => ({
    color: theme.colors.textColor,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24,
    letterSpacing: 0,
    lineHeight: 32,
  }),
  subHeaderContainerStyle: {
    marginBottom: 5,
    height: 46,
    overflow: 'hidden',
  },
  scrollViewStyle: {
    flexDirection: 'row',
    height: 182,
  },
  titleContainerStyle: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginRight: 15,
  },
  titleStyle: theme => ({
    color: theme.colors.textColor,
    fontSize: Fonts.size.regularSmall,
    fontWeight: Fonts.type.bold.fontWeight,
    letterSpacing: 0,
    lineHeight: 22,
  }),
  tabsContainer: {
    marginBottom: 20,
    paddingLeft: 16,
  },
  scrollableContentStyle: (theme, isExpandedTray) => ({
    borderBottomWidth: isExpandedTray ? 1 : 0,
    borderBottomColor: theme.colors.borderColorSix,
    marginLeft: -16,
  }),
  flatListStyle: isExpandedTray => ({
    paddingLeft: isExpandedTray ? 17 : 0,
    paddingBottom: isExpandedTray ? 150 : 0,
    marginLeft: 16,
    paddingRight: 16,
  }),
  bottomBarBackground: (theme, isExpandedTray) => ({
    position: 'absolute',
    bottom: 0,
    left: -20,
    width: Dimensions.get('window').width + 20,
    height: 85,
    backgroundColor: theme.colors.backgroundColorSix,
    borderTopWidth: isExpandedTray ? 1 : 0,
    borderTopColor: theme.colors.borderColorSix,
  }),
  footerContainerStyle: {
    flex: 1,
    marginTop: 5,
    marginBottom: isIPhoneWithNotch ? 90 : 70,
    overflow: 'hidden',
  },
  footerAnimatedViewStyle: {
    flex: 1,
  },
  headerContainerStyle: isExpandedTray => ({
    marginTop: 5,
    overflow: 'hidden',
    marginLeft: isExpandedTray ? 15 : 0,
  }),
  headerAnimatedViewStyle: {
    flex: 0,
    marginBottom: 12
  },
  headerButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 10,
    marginTop: 14,
    marginBottom: -7,
  },
  expandedTrayHeaderText: theme => ({
    fontSize: 24,
    marginTop: 4,
    color: theme.colors.textColor,
    fontFamily: Fonts.type.VodafoneLt,
    letterSpacing: 0,
    lineHeight: 30,
  }),
  expandedTrayButton: { height: 30 },
  expandedTrayButtonTitle: {
    ...Fonts.type.bold,
    marginHorizontal: 16,
    fontSize: 16,
  },
  listContentContainer: { paddingBottom: 300, paddingLeft: 16, overflow: 'hidden' },
});
